/*SYSTEM IMPORTS*/
import React from 'react'

import './style'
import './media'

/*Ui*/
import Cont from 'components/ui/Cont'
import EducationTable, {EducationTableItem} from 'components/ui/EducationTable'
import { IsArray } from 'helpers/ValueTests'

/*CORES*/
import AppCore from 'cores/AppCore'

/*Images*/

const ContEducation = ({ id, user: { education = [] } }) => (
    <React.Fragment>
        {IsArray(education) && education.length > 0 && <Cont id={`block-${id}`} className="cont-education">
            <h2>
                { AppCore.Interfaces.t( "DoctorLanding.Ui.ContEducation.Index.Title" ) }
            </h2>

            <EducationTable
                TitleYear={ AppCore.Interfaces.t( "DoctorLanding.Ui.ContEducation.Index.TitleYear" ) }
                TitleName={ AppCore.Interfaces.t( "DoctorLanding.Ui.ContEducation.Index.TitleName" ) }
            >
                { education.map(item => ( <EducationTableItem
                    key={item.id}
                    year={item.graduation_date}
                    name={item.university_title}
                /> ))}
            </EducationTable>
        </Cont>}
    </React.Fragment>
)

export default ContEducation